import { useState, type FormEvent } from 'react';

interface SearchBarProps {
  initialValue?: string;
  placeholder?: string;
  onSubmit: (value: string) => void;
}

export function SearchBar({
  initialValue = '',
  placeholder = 'Search for your device…',
  onSubmit,
}: SearchBarProps) {
  const [value, setValue] = useState(initialValue);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit(value.trim());
  };

  return (
    <form onSubmit={handleSubmit} role="search" className="w-full">
      <label htmlFor="search-input" className="sr-only">
        Search devices
      </label>
      <input
        id="search-input"
        type="search"
        className="pill-input"
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </form>
  );
}
